import { api, throwApiError } from "../../../api/api";

export type AuditActorType = "STAFF" | "FREELANCER" | "EMPLOYEE" | "KIOSK" | "PUBLIC" | "SYSTEM";

export const ACTOR_TYPE_LABELS: Record<AuditActorType, string> = {
  STAFF: "Usuário",
  FREELANCER: "Freelancer",
  EMPLOYEE: "Colaborador",
  KIOSK: "Quiosque",
  PUBLIC: "Público (sem login)",
  SYSTEM: "Sistema",
};

/** Valor da coluna `module`: o `AccessModule` da rota ou `COMPARTILHADO`. */
export const MODULE_LABELS: Record<string, string> = {
  OPERACOES: "Operações",
  PROCESSOS: "Processos",
  DP: "Departamento Pessoal",
  FINANCEIRO: "Financeiro",
  ESTOQUE: "Estoque",
  ADMINISTRACAO: "Administração",
  COMPARTILHADO: "Compartilhado",
};

/** Linha da lista (`GET /audit-logs`). O corpo e o antes/depois só vêm no detalhe. */
export type AuditLogRow = {
  id: string;
  occurredAt: string;
  actorType: AuditActorType;
  actorUserId: string | null;
  actorEmployeeId: string | null;
  actorFreelancerId: string | null;
  actorKioskDeviceId: string | null;
  actorLabel: string;
  module: string | null;
  action: string;
  summary: string;
  entityType: string | null;
  entityId: string | null;
  method: string | null;
  route: string | null;
  statusCode: number | null;
  success: boolean;
};

export type AuditLogDetail = AuditLogRow & {
  ip: string | null;
  userAgent: string | null;
  changes: Record<string, { before: unknown; after: unknown }> | null;
  payload: unknown;
};

export type AuditLogFilters = {
  from?: string;
  to?: string;
  actor?: string;
  actorType?: AuditActorType | "";
  module?: string;
  action?: string;
  entityType?: string;
  entityId?: string;
  success?: "true" | "false" | "";
  q?: string;
};

/** Tira os filtros vazios: o backend valida o que recebe. */
const clean = (filters: AuditLogFilters) =>
  Object.fromEntries(Object.entries(filters).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export const listAuditLogsApi = async (
  filters: AuditLogFilters,
  cursor?: string | null,
): Promise<{ items: AuditLogRow[]; nextCursor: string | null }> => {
  try {
    const { data } = await api.get("/audit-logs", { params: { ...clean(filters), cursor: cursor || undefined, limit: 50 } });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao carregar os logs de auditoria.");
    throw error;
  }
};

export const getAuditLogApi = async (id: string): Promise<AuditLogDetail> => {
  try {
    const { data } = await api.get(`/audit-logs/${id}`);
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao abrir o registro do log.");
    throw error;
  }
};

export const exportAuditLogsApi = async (filters: AuditLogFilters): Promise<Blob> => {
  try {
    const { data } = await api.get("/audit-logs/export", { params: clean(filters), responseType: "blob" });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao exportar os logs de auditoria.");
    throw error;
  }
};
